module.exports = __webpack_public_path__ + "img/20190719163753925.78f9f0ec.png";